import { CartFund, PRODUCTS, ProductType, UnitCategoryCode } from 'cart-model';

export function cartPayload(carts: CartFund[]) {
  return {
    product_count: carts.length,
    fund_name: uniqueArray(carts.map(cart => cart.fund.name)),
    fund_type: uniqueArray(carts.map(cart => cart.fund.fundType.name)),
    umbrella_name: uniqueArray(carts.map(cart => cart.fund.umbrella ? cart.fund.umbrella.name : null)),
    investment_horizon: uniqueArray(carts.map(cart => cart.fund.horizonValue)),
    fund_id: uniqueArray(carts.map(cart => cart.fund.id)),
    category_unit: uniqueArray(carts.map(cart => PRODUCTS[cart.productType].unitCategory)),
    product_context: uniqueArray(carts.map(carts => PRODUCT_TYPE_MAPPING[carts.productType])),
    analizy_online: uniqueArray(carts.map(cart => cart.fund.analizyOnlineRating)),
    mgmt_admin_fee: carts.map(cart => cart.fund.costsForUnitCode[getUnitCategory(cart.productType)])
        .filter(value => value !== undefined)
        .map(value => value.ongoingChargePercentage),
    fund_price: carts.map(cart => cart.fund.quotesForUnitCode[getUnitCategory(cart.productType)])
        .filter(price => price !== undefined)
        .map(price => price.value),
    fund_amount: carts.map(cart => cart.amount),
    order_total: carts.reduce((amount, cart) => amount + cart.amount, 0),
  }
}

function uniqueArray(array: Array<any>): Array<any> {
  return Array.from(new Set(array));
}

const PRODUCT_TYPE_MAPPING: Record<ProductType, string> = {
  [ProductType.funds]: 'investment fund',
  [ProductType.ike]: 'ike',
  [ProductType.ikze]: 'ikze',
};

function getUnitCategory(productType: ProductType): UnitCategoryCode {
  return PRODUCTS[productType].unitCategory;
}
